// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Alert } from '@metarouter-private/mr-mui';

import FileUploadButton from 'ion-experimental/app/shared/components/FileUploadButton';

export default function FileSelector({
  selectedFile,
  fileCount,
  onFileSelect,
  hasError,
  pipelinesLoading,
  hasPipelines,
}) {
  return (
    <Stack spacing={3}>
      <Typography variant="body1">
        Upload a YAML file containing multiple Analytics File configurations (maximum 100 files). The system will
        process each configuration and create Analytics Files for the corresponding pipelines.
      </Typography>

      {!pipelinesLoading && !hasPipelines && (
        <Alert severity="error">
          <Typography variant="body2">
            <strong>No pipelines found.</strong> You must have at least one pipeline before you can upload Analytics
            Files. Each Analytics File must be associated with a pipeline via its writeKey.
          </Typography>
        </Alert>
      )}

      <FileUploadButton
        accept=".yaml,.yml"
        onChange={onFileSelect}
        helperText="Select a YAML file (.yaml or .yml)"
        testId="bulk-upload-file-input"
        disabled={!pipelinesLoading && !hasPipelines}
      />
      {selectedFile && !hasError && (
        <Alert severity="info">
          <Typography variant="body2">
            <strong>File selected:</strong> {selectedFile.name}
          </Typography>
          <Typography variant="body2">
            <strong>Files detected:</strong> {fileCount}
          </Typography>
        </Alert>
      )}
      {hasError && (
        <Alert severity="error">
          <Typography variant="body2">
            The selected file contains {fileCount} Analytics File configurations. The maximum allowed is 100 files per
            upload. Please split your upload into smaller batches.
          </Typography>
        </Alert>
      )}
    </Stack>
  );
}

FileSelector.propTypes = {
  selectedFile: PropTypes.object,
  fileCount: PropTypes.number.isRequired,
  onFileSelect: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  pipelinesLoading: PropTypes.bool.isRequired,
  hasPipelines: PropTypes.bool.isRequired,
};
